import { pick } from 'lodash';
import type { BaseGroupUser } from './types';

export const prepareGroupUser = (
  student: RecursivePartial<BaseGroupUser>,
  classId?: number,
  customerUserId?: number,
  levelId?: number
): MutationBody => ({
  data: {
    type: 'GroupUser',
    attributes: {
      ...pick(student, ['name', 'type', 'order'])
    },
    ...(classId || customerUserId || levelId
      ? {
          relationships: {
            ...(classId
              ? { group: { data: { id: `/api/v2/groups/${classId}`, type: 'Group' } } }
              : {}),
            ...(customerUserId
              ? {
                  user: {
                    data: {
                      id: `/api/v2/customers-users/${customerUserId}`,
                      type: 'CustomersUsers'
                    }
                  }
                }
              : {}),
            ...(levelId
              ? { level: { data: { id: `/api/v2/levels/${levelId}`, type: 'Level' } } }
              : {})
          }
        }
      : {})
  }
});
